/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import CustomTooltip from "../../CustomTooltip";
import {
    EmailSubsectionChip, IconCheckboxChecked, IconCheckboxUnchecked, IconCloseChip,
    PersonChip,
    PhoneSubsectionChip,
} from "../../buttons/IconButtons";
import CustomCard from "../../CustomCard";
import {CustomCheckbox} from "../../CustomCheckbox";
import React from "react";

/**
 * Card component used to display selected user information including
 * full name, email, phone number, and selection controls.
 *
 * @param {Object} props - Component properties
 * @param {string} props.keyId - Unique identifier key for the item
 * @param {Object} props.item - Item data to display
 * @param {string|number} props.item[keyId] - Unique identifier value
 * @param {string} props.item.fullName - User full name
 * @param {string} props.item.email - User email address
 * @param {string} [props.item.phoneNumber] - User phone number (optional)
 * @param {boolean} props.item.disabled - Indicates if the item is disabled
 * @param {boolean} [props.item.checked] - Indicates if the item is selected (checkbox state)
 * @param {Function} props.onDelete - Callback executed when the delete action is triggered
 * @param {Function} [props.handleCheckboxChange] - Optional handler for checkbox state changes
 *
 * @returns {JSX.Element} User card component with selection and delete functionality
 */
const SelectedUserEmailPhoneCard = (
    {
        keyId,
        item,
        onDelete,
        handleCheckboxChange
    }
) => {

    return (
        <CustomCard
            classes="w-100"
            classCard="card-border-8px"
            classContent={`background-shades-50`}
        >
            <div className="row">
                <div className={"d-flex justify-content-between p-0"}>
                    { handleCheckboxChange &&
                        <div className={"align-top mr-3"}>
                            <CustomCheckbox
                                id={'cb_sue_row_' + keyId}
                                checked={item?.checked}
                                onChange={(e) => {
                                    handleCheckboxChange({
                                        target: {
                                            [keyId]: item[keyId],
                                            checked: e.target.checked,
                                        },
                                    });
                                }}
                                disabled={item?.disabled}
                                icon={<IconCheckboxUnchecked className={"icon-color-general-950"}/>}
                                checkedIcon={<IconCheckboxChecked className={"icon-color-shades-800"}/>}
                                disableRipple={true}
                            />
                        </div>
                    }

                    <div className={"flex-grow-1 minw-0 mr-1 mt-2"}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className={`col-12 p-0`}>
                                <div className='d-flex align-items-center justify-content-start'>
                                    <div><PersonChip className="mr-8px mb-1" /></div>
                                    <div className={`mr-5 flex-grow-1 minw-0 p-0`}>
                                        <CustomTooltip
                                            text={item?.fullName}
                                            classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                    { onDelete &&
                                        <div className={"position-absolute r-0px t-negative-4px"}>
                                            <IconCloseChip
                                                className='icon-color-shades-400 icon-hover-shades-950'
                                                onClick={() => onDelete(item)}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="border-bottom-shades-300 my-2" />

                        <div className='d-flex align-items-center justify-content-between '>
                            <div className={`${item?.phoneNumber ? 'col-6' : 'col-12'} pl-0`}>
                                <div className="d-flex align-items-center">
                                    <div><EmailSubsectionChip className="mr-8px mb-1" /></div>
                                    <div className={"minw-0"}>
                                        <CustomTooltip
                                            text={item?.email}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            {item?.phoneNumber &&
                            <div className='col-6 px-0'>
                                <div className="d-flex align-items-center">
                                    <div><PhoneSubsectionChip className="mr-8px mb-1" /></div>
                                    <div className={"minw-0"}>
                                        <CustomTooltip
                                            text={item?.phoneNumber}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </CustomCard>
    );

}
export default SelectedUserEmailPhoneCard
